export default function Footer() {
  return (
    <footer className="bg-abyss border-t border-pearl/10 pt-16 pb-10" data-testid="footer">
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <p className="font-display text-3xl text-pearl/90 mb-8">La Traversée</p>

        <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 mb-12">
          <a href="#mentions" className="text-pearl/60 hover:text-aqua transition-colors text-sm" data-testid="footer-mentions">
            Mentions légales
          </a>
          <a href="#confidentialite" className="text-pearl/60 hover:text-aqua transition-colors text-sm" data-testid="footer-privacy">
            Politique de confidentialité
          </a>
          <a href="#cgv" className="text-pearl/60 hover:text-aqua transition-colors text-sm" data-testid="footer-cgv">
            Conditions générales
          </a>
          <a href="#contact" className="text-pearl/60 hover:text-aqua transition-colors text-sm" data-testid="footer-contact">
            Contact
          </a>
        </nav>

        <div className="rule mb-10" />

        <p className="text-pearl/55 leading-relaxed max-w-3xl mx-auto text-[12px] md:text-[12px]">
          Ce site ne fait pas partie du site YouTube™️, Google™️, Facebook™️, Google Inc.
          ou Facebook Inc. De plus, ce site n'est PAS approuvé par YouTube™️, Google™️ ou
          Facebook™️ en aucune façon. FACEBOOK™️ est une marque de commerce de FACEBOOK,
          Inc. GOOGLE™️ et YOUTUBE™️ sont des marques de commerce de GOOGLE Inc.
        </p>

        <p className="text-pearl/70 mt-8 text-[12px] tracking-wide">
          © 2024-2033 GILLES DELIEUZE Tous droits réservés
        </p>
      </div>
    </footer>
  );
}
